export const ItemBrandModel = {
  name: '',
}
